module.exports = __webpack_public_path__ + "img/img4zhounq-2.4f15ea6e.png";